function getLast12MonthsData(rawData) {
  const result = [];
  const dataMap = Object.fromEntries(
    rawData.map((item) => [item.month, item.count])
  );

  const now = new Date();
  let currentMonth = now.getMonth(); // 0 = Jan, 11 = Dec
  let currentYear = now.getFullYear();

  for (let i = 11; i >= 0; i--) {
    let month = currentMonth - i;
    let year = currentYear;

    if (month < 0) {
      month += 12;
      year -= 1;
    }

    const monthStr = `${year}-${String(month + 1).padStart(2, "0")}`;
    result.push({
      month: new Date(`${monthStr}-01`),
      count: dataMap[monthStr] || 0,
    });
  }

  return result;
}

export default getLast12MonthsData;
